import ApiService from '../apiservice';
import ErroValidacao  from '../exception/ErroValidacao'

class GerarAtaService extends ApiService{

    
   constructor(){
      super('/api/ata')
   }
 
    gerarAtaPorData(credenciais){
        return this.put('/gerarAtaPorData', credenciais)
    }

    conultaAtaPorProcesso(credenciais){
        return this.put('/buscarAtaPorProcesso', credenciais)
    }

    conultaAtaPorData(credenciais){
        return this.put('/buscarAtaPorData', credenciais)
    }

}

export default GerarAtaService;